import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import styled from 'styled-components';
import { deleteMarker } from '../../../../store/actions/sketchActions';
import { openDeleteMarkerModal } from '../../../../store/actions/sketchActions'
import ReactModal from 'react-modal';
import FloorMarkerListDeleteModal from './FloorMarkerListDeleteModal';
import { dateConverter } from '../../../../helper/Helper';
import { get } from 'lodash';
import { getFloorAndItsElevationsStats } from '../../../../helper/StatsHelper';
class FloorMarkersList extends Component {
    constructor(props) {
        super(props)

        this.state = {
            showVisibileModal: false,
        }
    }
    /// README: MODAL CONTROLLING
    handleOpenModal = (proid, markerid) => {
        this.props.openDeleteMarkerModal();
        this.setState({
            showVisibileModal: true,
            proid,
            markerid,
        });
    }

    handleCloseModal = () => {
        this.setState({ showVisibileModal: false });
    }


    handleClick = (proid, markerid) => {
        // console.log(proid,markerid)
        this.props.deleteMarker(proid, markerid);

    }
    render() {
        const { floorMarkers, handleSetMarkerId, themeColors, modalStyles, sketch, tagLimitReached, defectMarker, defectMarkers, alu, snagDetail, userData } = this.props;
        const { uid, employeeid } = userData;
        const { accessMap, floorsAndElevations, markerCount } = snagDetail;
        const { markerDeletionAccess } = alu;
        var ueid = uid + employeeid;
        var accessLevel = accessMap ? ueid in accessMap ? accessMap[ueid]['access'] : alu.invalid : alu.invalid;
        var isMarkerDeletionToggleAllowed = markerDeletionAccess[accessLevel];

        const { isMarkerDeleted } = sketch;
        // console.log(isMarkerDeleted);

        const ViewTagDetailButton = styled.div`
    .btn {
        color: ${themeColors.themeColor};
        border-color: ${themeColors.themeColor};
        background-color: #fafafa;
        margin: 2px;  
 
        &:hover { 
            color: #fafafa;
            background-color: ${themeColors.themeColor};
        }

        &:active {
            color: #fafafa; 
            background-color: ${themeColors.themeColor};
        }
    }
`;
        const floorMarkersList = (floorMarkers ? floorMarkers.map(eachFloorMarkerDetail => {
            // console.log(eachFloorMarkerDetail.deadline)
            const { fullDefects, percentageFullComplete } = getFloorAndItsElevationsStats(eachFloorMarkerDetail.markerid, floorsAndElevations, markerCount);
            const proid = eachFloorMarkerDetail.proid;
            const markerid = eachFloorMarkerDetail.markerid;
            var tagOrElevationDateCreated = dateConverter(eachFloorMarkerDetail.dateCreated).parsedDate;
            var tagDeadline = dateConverter(eachFloorMarkerDetail.deadline).parsedDate;

            const elevationPillColor = fullDefects === 0 ? 'purple' : fullDefects >0 && percentageFullComplete === 0 ?'red': fullDefects>0 && percentageFullComplete<100.0?'orange':fullDefects>0&& percentageFullComplete === 100.0?'green':'';
            const elvationPillText = fullDefects === 0 ? 'No issues' : fullDefects >0 && percentageFullComplete === 0 ?'Pending': fullDefects>0 && percentageFullComplete<100.0?`${Math.round(percentageFullComplete)}% fixed`:fullDefects>0&& percentageFullComplete === 100.0?'All fixed':'';
            return (
                <div className="card h-100" key={eachFloorMarkerDetail.id} style={{ borderRadius: '20px', margin: '8px', overflow: 'auto' }}>
                    <ul className="list-group" >
                        <div className="list-group-item d-flex justify-content-between" style={{ borderRadius: '0px', textAlign: 'start' }}>

                            <div className="align-self-start">
                                <h5 style={{ fontWeight: 'bold' }}>{eachFloorMarkerDetail.title}</h5>
                                {
                                    eachFloorMarkerDetail.identifier !== "1" ?
                                        <p style={{ fontSize: '12px' }}><b style={{ color: themeColors.themeColor }}>Deadline: </b>{tagDeadline}</p>
                                        : <p style={{ fontSize: '12px' }}><b style={{ color: themeColors.themeColor }}>Contains: </b>{fullDefects} {defectMarkers}</p>}




                                {/* {tagLimitReached ?
                                    <div className="d-flex justify-content-between">
                                        <ViewTagDetailButton themeColors={themeColors}>

                                           
                                        </ViewTagDetailButton>
                                    </div>
                                    : <div className="d-flex justify-content-between">
                                        <ViewTagDetailButton themeColors={themeColors}>
                                            <button className="btn btn-default btn-sm float-left" onClick={() => { handleSetMarkerId(markerid, true) }}>View {eachFloorMarkerDetail.identifier !== "1" ? defectMarker : 'elevation'}</button>
                                            {isMarkerDeletionToggleAllowed ? <button className="btn btn-default btn-sm float-left" onClick={() => { this.handleOpenModal(proid, markerid) }}>Delete {eachFloorMarkerDetail.identifier !== "1" ? defectMarker : 'elevation'}</button> : <React.Fragment />}
                                        </ViewTagDetailButton>
                                    </div>} */}
                            </div>

                            <div className="ml-2 align-self-start">
                                {eachFloorMarkerDetail.identifier !== "1" ? eachFloorMarkerDetail.isDeadlineComplete ?
                                    <span className="badge badge-pill" style={{backgroundColor:'green',color:'white'}}> Fixed</span> :
                                    <span className="badge badge-pill " style={{backgroundColor:'red',color:'white'}}> Pending </span> :
                                    <span className="badge badge-pill" style={{backgroundColor: elevationPillColor,color:'white'}}>{elvationPillText}</span>
                                }
                            </div>
                        </div>
                        {/* Card footer */}
                        <div className="card-footer mt-auto" style={{ borderRadius: '5px' }}>
                            <div className="row">
                                <div className="col col-12">
                                    <div className="d-flex">
                                        <div className="flex-fill">
                                            <ViewTagDetailButton themeColors={themeColors}>
                                                {tagLimitReached ?
                                                    <button className="btn btn-default btn-sm float-left" disabled onClick={() => { handleSetMarkerId(markerid, true) }}>View {eachFloorMarkerDetail.identifier !== "1" ? defectMarker : 'elevation'}</button>
                                                    :
                                                    <button className="btn btn-default btn-sm float-left" onClick={() => { handleSetMarkerId(markerid, true) }}>View {eachFloorMarkerDetail.identifier !== "1" ? defectMarker : 'elevation'}</button>
                                                }
                                            </ViewTagDetailButton>
                                        </div>
                                        <div className="align-self-start pl-2">
                                            <ViewTagDetailButton themeColors={themeColors}>
                                                {tagLimitReached ? <button className="btn btn-default btn-sm float-left" disabled onClick={() => { this.handleOpenModal(proid, markerid) }}>Delete {eachFloorMarkerDetail.identifier !== "1" ? defectMarker : 'elevation'}</button>
                                                    : isMarkerDeletionToggleAllowed ? <button className="btn btn-default btn-sm float-left" onClick={() => { this.handleOpenModal(proid, markerid) }}>Delete {eachFloorMarkerDetail.identifier !== "1" ? defectMarker : 'elevation'}</button> : <React.Fragment />
                                                }
                                            </ViewTagDetailButton>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ul>
                </div>

            )
        }) : <React.Fragment />)

        return (
            <div style={{ maxHeight: '500px', overflow: 'auto' }}>

                {floorMarkersList}

                {/* PART MARKER DELETEION MODAL  */}
                <ReactModal
                    style={modalStyles}
                    isOpen={this.state.showVisibileModal && isMarkerDeleted}
                    onRequestClose={() => { this.handleCloseModal() }}
                    contentLabel="Delete Tag"
                    ariaHideApp={false}
                >
                    <button className="close" onClick={() => { this.handleCloseModal() }}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <FloorMarkerListDeleteModal proid={this.state.proid} markerid={this.state.markerid} />
                </ReactModal>

            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        floorMarkers: state.firestore.ordered.FloorMarkers,
        themeColors: state.theme,
        modalStyles: state.appControl.modalStyles,
        sketch: state.sketch,
        alu: state.alu,
        snagDetail: get(state.firestore.data, `Snag.${state.project.proid}`),
        userData: state.firebase.profile,

    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        deleteMarker: (proid, markerid) => dispatch(deleteMarker(proid, markerid)),
        openDeleteMarkerModal: () => dispatch(openDeleteMarkerModal()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FloorMarkersList);




